module.exports = __webpack_public_path__ + "images/a830d205678207d79a386e33291d78c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-story00.jpg
// module id = ./webpack/assets/img/wheels-story00.jpg
// module chunks = 0